import ScopriBsGommaCarboncino from "./GommaCarboncino";
import ScopriBsIntervisteOmaggio from "./ScopriBsIntervisteOmaggio";
import ScopriBsNotImg from "./ScopriBsNotImg";
import ScopriBsSpeciale from "./ScopriBsSpeciale";
import ScopriBsWithtImg from "./ScopriBsWithImg";

const ScopriBsComponent = ({ data, index }) => {
  switch (index) {
    case 0:
      return <ScopriBsNotImg post={data.post} index={index} />;
    case 1:
      return <ScopriBsSpeciale post={data.post} index={index} />;
    case 2:
      return <ScopriBsIntervisteOmaggio post={data.post} index={index} />;
    case 3:
      return <ScopriBsIntervisteOmaggio post={data.post} index={index} />;
    case 4:
      return <ScopriBsWithtImg post={data.post} index={index} />;
    default:
      return <ScopriBsGommaCarboncino post={data.post} index={index} />;
  }
};

export default ScopriBsComponent;
